<template>
  <div>
    <div class="content contentTerms">
      <div class="mainDiv">
        <article class="main">
          <section class="topTitle">
            <img src="/static/img/work/argreementLogo.png" alt="">
            薄盒用户协议
          </section>
          <section class="intro bold">
            <h4 style="margin-bottom: 5px; ">尊敬的用户（“您”）：</h4>
            <p style="word-break: break-all;">
              欢迎您使用薄盒平台（包括薄盒APP和薄盒官方网站https://mintstech.cn/，以下简称“本平台”），本平台由北京擘盒科技有限公司（以下简称“我们”）运营。本平台是一款为用户提供购买、收集和展示潮玩藏品的平台。使用我们的服务前请您仔细阅读以下条款，使用我们的服务则表明您已知悉并接受这些条款（以下简称“本协议”）。若您不接受有关条款和条件的约束，请立即停止使用我们的服务。<br />
              任何未满18周岁的未成年人或不具备完全民事行为能力之人均不得注册账号或使用我们提供的服务。</p>
          </section>
          <section class="privacy-content">
            <ul>
              <li>
                <div class="rt">
                  <p>一、签约主体以及协议范围</p>
                  <ul>
                    <li>
                      <div class="rt">
                        <p>1.1协议主体及范围</p>
                        <p class="desc" style="word-break: break-all;">
                          本协议是您与我们就使用本平台（https://mintstech.cn/）服务而共同订立的协议。<br>
                          本协议条款的效力及于我们所提供的一切产品和服务，您在享受本平台任何服务时，应当受本协议的约束。本协议项下的产品和服务是指由我们发布的包括但不限于网络媒体、互联网增值、互动娱乐、电子商务、广告等互联网产品和服务（形式包括但不限于视频、音频、评论、跟帖、弹幕、图片、软件、技术代码等）。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt bold">
                        <p>1.2订立前提</p>
                        <p class="desc"><span
                            class="bold">潮玩藏品是收藏品，您在此承诺并保证，您主要将本平台上的潮玩藏品用作收藏、娱乐和游戏的对象，而不是用于投资、投机或炒作，该等承诺与保证将作为您与我们订立本协议的前提。</span>
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt bold">
                        <p>1.3免责条款</p>
                        <p class="desc"><span
                            class="bold">为了让您更好地使用我们提供的产品和服务，请您务必审慎阅读、充分理解本协议各条款内容，特别是免除或者限制责任的条款。本协议中限制、免责条款可能以加粗形式提醒您注意。<br>当您注册/登录本平台，即视为您已充分阅读并接受本协议的所有条款，您同意本协议对您与我们双方具有法律约束力。
                          </span></p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>1.4协议组成部分</p>
                        <p class="desc">
                          除本协议明确规定外，对于我们发布的由著作权人或其他权利人销售的产品和服务，我们有权在本协议的基础上通过单独的产品和服务协议（以下简称“单项产品协议”）加以规范，您须在使用有关产品或服务时另行了解与确认。单项产品协议与本协议有冲突的地方，以单项产品协议为准。如您使用该产品或服务，即视为对相关单项产品协议的接受。<br />
                          本协议内容同时包括所有我们已经发布或未来可能发布的各类规则、公告或通知，以及您在使用某一特定产品或服务时同意的单项产品协议，前述规则、公告、通知和单项产品协议一经发布即为本协议不可分割的组成部分，对您和我们双方具有法律约束力。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt bold">
                        <p>1.5协议的修订</p>
                        <p class="desc">
                          <span class="bold">
                            我们有权根据需要不时地修订本协议及/或各类规则（包括但不限于制定新的条款和修改既有条款），一旦发生变动，我们将尽可能及时地在平台上以在线公告的方式进行变更公告，而无须另行单独通知您。修订后的协议和规则一经公布，立即或在公告明确的特定时间生效。若您在前述公告修订后继续使用我们的产品或服务，即视为您已阅读、理解并接受经过修订的协议和规则。若您不同意修订，应当立即停止使用本平台。
                          </span>
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>

              <li>
                <div class="rt">
                  <p>二、账号的注册、使用与安全</p>
                  <ul>
                    <li>
                      <div class="rt">
                        <p>2.1注册资格</p>
                        <p class="desc">
                          您确认，<span
                            class="bold">您应当年满18周岁并具备完全民事行为能力，方可注册使用本平台。</span>如果您不满18周岁或不具有完全民事行为能力，您不应使用本平台，否则您及您的法定监护人应依照法律规定承担因此而导致的一切后果。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>2.2账号注册</p>
                        <p class="desc">
                          您在注册时应当使用手机号、短信验证码、邮箱、邮箱验证码和好友邀请码，填写昵称、性别，以完成注册。当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，您可使用我们向您提供的账号并成为我们的用户。您的账号是您用以登录并使用我们服务、购买潮玩藏品的凭证<span
                            class="bold">但请您特别注意，我们仅许可您出于个人而非商业目的使用该账号。我们保留该账号以及与注册、使用该账号相关的服务数据和记录的所有权，包括但不限于所有注册、登录、服务日志、客服记录和相关使用数据等。</span>
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>2.3账号信息</p>
                        <p class="desc">
                          您应当按照法律法规要求或按相应页面的提示，准确提供并及时更新您的账号信息，以使之真实、及时、完整和准确，您须对所提供信息的真实性、合法性、有效性及完整性负责。如您提供的资料错误、不实、过时或不完整的，我们可以向您发出询问及/或要求改正的通知，您应按照我们的要求配合提供或者更新相关信息和资料。<span
                            class="bold">因您填写的信息、资料不真实、不及时、不完整或不准确的，您应承担您不能使用我们的账号（不能注册成功、或账号被冻结、注销）或在使用过程中部分功能受到限制的后果和损失。</span>
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>2.4昵称</p>
                        <p class="desc">您可以对账号设置昵称，您设置的昵称不得侵犯或涉嫌侵犯他人的合法权益。设置昵称时遵守以下规定：</p>
                        <ul>
                          <li>
                            <div class="rt">
                              <p>（1）不以党和国家领导人或其他社会名人的真实姓名、字号、艺名、笔名注册；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（2）不以国家机构或其他机构的名称注册；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（3）不注册名称不文明、不健康的账号，或包含歧视、侮辱、猥亵类词语的账号；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（4）不注册易产生歧义、引起他人误解的账号；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（5）不得危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（6）不得损害国家荣誉和利益的，损害公共利益；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（7）不得煽动民族仇恨、民族歧视，破坏民族团结；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（8）不得破坏国家宗教政策，宣扬邪教和封建迷信；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（9）不得散布谣言，扰乱社会秩序，破坏社会稳定；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（10）不得散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（11）不得侮辱或者诽谤他人，侵害他人合法权益；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（12）不得违反宪法或法律法规规定；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（13）不得含有法律、行政法规禁止的其他内容。</p>
                            </div>
                          </li>
                          <li>

                            <div class="rt">
                              <p class="bold">
                                如您设置的昵称涉嫌侵犯他人合法权益或者含有法律、行政法规禁止的其他内容，我们有权拒绝或终止向您提供部分或全部软件服务。我们对此不承担任何责任，您将承担因此产生的任何直接或间接损失及不利后果。
                              </p>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>2.5禁止外借</p>
                        <p class="desc bold">
                          您的账号仅限于您本人使用，未经我们书面同意，禁止以任何形式赠与、借用、出租、转让、售卖或以其他方式许可他人使用该账号。如果我们发现或者有合理理由认为使用者并非账号初始注册人，我们有权暂时或终止向该注册账号提供服务，并有权注销该账号，而无需向注册该账号的用户承担法律责任。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>2.6禁止恶意注册</p>
                        <p class="desc">禁止恶意注册账号，包括但不限于频繁、批量注册账号。如果我们发现或者有合理理由认为您有恶意注册账号的行为，我们有权拒绝您的恶意注册，或注销恶意注册的账号。</p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>2.7账号保管</p>
                        <p class="desc">
                          您须妥善保管您的账号，在任何情况下不向他人透露账号。您需确保您在购买潮玩藏品和使用我们的服务后，以正确步骤离开本平台。您对以您注册账号的名义所从事的活动承担全部法律责任，包括但不限于在本平台购买潮玩藏品、支付款项、信息披露、信息发布、网上点击同意或提交各类规则协议等操作行为可能引起的一切法律后果。 <span
                            class="bold">  因您的行为或因其他因素致您账号遭受攻击、诈骗、盗窃等导致的账号泄露的损失及后果，我们不承担任何责任。</span>
                           如发现他人未经授权使用您的账号，您应立即通知我们，我们将协助您冻结账号或进行其他安全设置。
                          <span class="bold"> 请您理解我们对您的请求采取行动需要合理时间，我们对在采取行动前已经产生的以及由您引发的后果（包括但不限于您的任何损失）不承担任何责任。</span>
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>2.8实名认证</p>
                        <p class="desc">为了您更好地使用我们的各项服务，保障您的账号安全，我们可能要求您按相关法律法规规定完成实名认证及/或对您进行“了解你的客户”调查，并要求您进一步提供相关资料。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>2.9账号的冻结及申诉</p>
                        <p class="desc">如发生以下情况，我们有权冻结您的账号（全部或部分权限或功能），并通过适当的方式和途径通知您：</p>
                        <ul>
                          <li>
                            <div class="rt">
                              <p>（1）违反本协议，以及潮玩藏品购买、展示和服务的相关规则、管理规范、服务说明以及其他使用协议/条款的；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（2）违反国家法律、法规、政策、法律文书的规定的；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（3）您遭到他人投诉，且对方已经提供了相关证据，而您未按照我们的要求提供相反证据的；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（4）我们根据合理分析判断您的账号操作存在异常、进行可疑交易或存在欺诈、洗钱的风险；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（5）为了保护我们及其他用户的合法权益；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（6）国家有权机关要求。</p>
                            </div>
                          </li>
                        </ul>
                        <p class="desc">
                          <span class="bold">
                            若您的账号被冻结，在解冻前您将暂时无法使用账号购买潮玩藏品。我们有权不经通知随时删除相关违规内容，并视行为情节对违规账号进行处理，处理方式包括但不限于警告、删除部分或全部订阅用户、限制或禁止使用全部或部分功能、账号封禁甚至注销，并有权视具体情况而公告处理结果。
                          </span>
                        </p>
                        <p class="desc">
                          您可以通过申诉程序，向我们申请解除上述冻结。为了您的账号安全，您应配合如实提供身份证明及相关资料，以及我们要求的其他信息或文件，以便我们进行核实和调查。我们有权决定是否同意您的申诉请求。
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>

              <li>
                <div class="rt">
                  <p>三、账号的注销</p>
                  <p class="desc">
                    您有权主动注销您的账号，您可以通过本平台“关于我们”页面提供的联系方式联系我们注销您的账号（但法律法规另有规定的或本政策另有约定的除外）。
                    <span class="bold">
                      一旦您注销账号，将无法登录原账号使用我们提供的产品和服务且自动放弃您已有的权益，因此请您谨慎操作。
                    </span>
                    <br />
                     在您的账号被您主动注销或由于违反上述第二条的约定被强制注销后，将可能产生包括但不限于如下结果需要您自行承担：</p>
                  <ul>
                    <li>
                      <div class="rt">
                        <p>3.1账号一旦注销，您将无法登录、使用该账号，即您将无法再以此账号登录、使用、继续使用本平台所有产品与服务；</p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>3.2账号一旦注销，您曾通过该账号登录、使用的本平台的产品与服务下的所有内容、信息、数据、记录及您已经购买的潮玩藏品将会被全部冻结，包括但不限于：</p>
                        <ul>
                          <li>
                            <div class="rt">
                              <p>（1）该账号购买的潮玩藏品或获得的实物收藏品的数字证书；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（2）该账号下的个人资料（例如：头像、昵称等）及绑定信息（例如：绑定手机号、邮箱等），以及该账号下的您的其他个人信息。同时您亦不再享有《<a
                                  href="/publicAgreement?agreementCode=H5YSZC"
                                  style="color:#83878B;font-weight:bold">薄盒隐私政策</a>》中约定的您对个人信息的权利，但法律法规另有约定的除外；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（3）该账号曾发表的所有内容（例如：文章、图片、评论、互动等）；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（4）其他与该账号相关的所有内容、信息、数据、记录（例如：收藏等）。</p>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>3.3您同意通过注销账号的方式放弃该账号在使用本平台产品与服务期间已产生的但未消耗完毕的权益及未来的预期利益。即账号一旦注销，您在该账号下的全部权益将会自动清除作废，包括但不限于：
                        </p>
                        <ul>
                          <li>
                            <div class="rt">
                              <p>（1）您尚未提现的账户余额；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（2）您在本平台发布的内容未来的收益权益；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（3）您在本平台的各类身份权益；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（4）其他已产生但未消耗完毕的权益或未来预期的收益。</p>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          3.4您的账号一旦注销，将无法恢复，即使您在注销后以相同手机号码再次向我们申请注册本平台账号，此时该账号将为全新的用户账号。因此，我们善意地提醒您在主动申请注销前对需要备份的内容提前自行做好备份，对需要提现的余额先行提现，对其他利益做出妥善安排，谨慎思考后做出注销决定；
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>3.5账号一旦注销，您与我们曾签署过的协议、文件等相应终止（但已约定继续生效的或法律法规另有规定的除外）；</p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>3.6其他因账号注销（可能）产生的结果。</p>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>

              <li>
                <div class="rt">
                  <p>四、我们的服务</p>
                  <ul>
                    <li>
                      <div class="rt">
                        <p>4.1潮玩藏品浏览、关注、分享、展示</p>
                        <p class="desc">
                          在您浏览本平台过程中，我们为您提供了信息分类、关键词检索、筛选、关注、展示等功能，以更好地匹配您的需求。您可以对您感兴趣的潮玩藏品进行浏览、关注、分享，并向他人展示您购买到的潮玩藏品。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>4.2购买盲盒</p>
                        <p class="desc">
                          盲盒由著作权人及相关权利人（以下称“销售方”）通过本平台发售，每个盲盒中包含的收藏品类型、收藏品数量不同，您可在盲盒详情页查看，但您将仅知晓潮玩藏品的类型和数量（例如：以视频或照片形式呈现的艺术作品、设计作品、绘画作品等），无法知晓具体的内容。销售方有权自主决定盲盒的类型、价格、数量，每个盲盒发售的数量不同，售完为止。<br />
                          您可以在平台上进入“盲盒”导航页面，选择发售中的盲盒，进入盲盒详情，了解盲盒的类型等信息。等候室开放后您可以加入等候室，到达盲盒购买时间则进入排队队列，队列轮到您后则可以购买盲盒。根据您购买盲盒的类型，您将收集到不同的潮玩藏品。
                        </p>
                      </div>
                    </li>

                    <li>
                      <div class="rt">
                        <p>4.3限时活动</p>
                        <p class="desc">您可以通过参与本平台的限时活动，或接受某些挑战任务，收集活动或任务指定潮玩藏品，获得对应的奖励。</p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>4.4广告营销</p>
                        <p class="desc">
                          您在本平台提交信息（包括但不限于邮箱、电话、姓名等），即视为您同意我们自行或者委托第三方广告商通过电子邮件、站内信、手机短信、电话等形式与您联系，向您发送简报、广告等商业推送。<br />
                          您可以按照商业广告信息中说明的退订方式退订广告，也可以通过本平台“关于我们”页面提供的联系方式联系我们取消广告推送，但是不得采用未经我们许可的方式屏蔽、过滤广告信息。</p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>4.5争议处理</p>
                        <p class="desc">对于您通过平台购买的实物产品，其本身存在质量问题或其他争议的，您可以向平台反应，由平台向您提供销售方的联系方式，由您向销售方维权。<br>
                          对于您通过平台购买的潮玩藏品，或如果在使用我们的服务过程中发生争议，您可以联系我们进行调解、协商和解决。您也可以向有关行政部门投诉或向本协议约定的管辖法院提起诉讼。</p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>4.6服务升级</p>
                        <p class="desc">
                          为增进用户体验、完善服务内容，我们将会改进、增强和进一步开发本平台的服务，您理解并同意，我们有权不向您特别通知而对本平台服务进行更新，或对本平台的部分功能进行改变或限制。</p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        4.7
                        对于您根据本协议、通过本平台购买的商品（包括潮玩藏品），您将有权利要求取得等额于您实际支付的全部价款的增值税发票，并通过平台发起开票请求。平台将把您的开票请求反馈至实际销售方。您认可并同意该发票将由实际的销售方负责开具。
                      </div>
                    </li>
                  </ul>
                </div>
              </li>

              <li>
                <div class="rt">
                  <p>五、使用规范</p>
                  <p class="desc">
                    您有权享受本平台提供的互联网技术服务和信息服务，通过本平台购买和展示潮玩藏品，或获得实物收藏品的证书。
                    <br>
                    <span class="bold">
                      在您遵守本协议的前提下，我们授予您关于本平台有限的、不可转让的、非独占的、可撤销的、仅为个人用途的非商业性使用的权利。在任何情形下，我们的内容及服务仅被许可由您个人使用而不得被出售或转让。我们保留本协议未特别授予的所有权利。您在使用我们的服务过程中，必须遵循以下原则：
                    </span>
                  </p>
                  <ul>
                    <li>
                      <div class="rt">
                        <p>
                          5.1您不得制作、复制、发布、传播含有下列内容的信息或从事相关行为，也不得为制作、复制、发布、传播含有下列内容的信息或从事相关行为提供便利。本条所述内容是指您使用本协议项下服务过程中所制作、上载、复制、发布、传播的任何内容，包括但不限于账号头像、昵称、评价等信息，或文字、语音、图片、视频、图文等发送、回复或自动回复消息和相关链接页面，以及其他使用账号或本平台服务所产生的内容。
                        </p>
                        <ul>
                          <li>
                            <div class="rt">（1）反对宪法所确定的基本原则的；</div>
                          </li>
                          <li>
                            <div class="rt">（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</div>
                          </li>
                          <li>
                            <div class="rt">（3）损害国家荣誉和利益的；</div>
                          </li>
                          <li>
                            <div class="rt">（4）歪曲、丑化、亵渎、否定英雄烈士事迹和精神，以侮辱、诽谤或者其他方式侵害英雄烈士的姓名、肖像、名誉、荣誉的；</div>
                          </li>
                          <li>
                            <div class="rt">（5）宣扬恐怖主义、极端主义或者煽动实施恐怖活动、极端主义活动的；</div>
                          </li>
                          <li>
                            <div class="rt">（6）煽动民族仇恨、民族歧视，破坏民族团结的；</div>
                          </li>
                          <li>
                            <div class="rt">（7）破坏国家宗教政策，宣扬邪教和封建迷信的；</div>
                          </li>
                          <li>
                            <div class="rt">（8）散布谣言，扰乱经济秩序和社会秩序的；</div>
                          </li>
                          <li>
                            <div class="rt">（9）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</div>
                          </li>
                          <li>
                            <div class="rt">（10）侮辱或者诽谤他人，侵害他人名誉、隐私和其他合法权益的；</div>
                          </li>
                          <li>
                            <div class="rt">（11）违反法律法规底线、社会主义制度底线、国家利益底线、公民合法权益底线、社会公共秩序底线、道德风尚底线和信息真实性底线的“七条底线”要求的。
                            </div>
                          </li>
                          <li>
                            <div class="rt">（12）相关法律法规或本协议、相关协议、规则等禁止的。</div>
                          </li>
                        </ul>
                        <p class="desc">同时，您应当防范和抵制制作、复制、发布含有下列内容的不良信息：</p>
                        <ul>
                          <li>
                            <div class="rt">（1）使用夸张标题，内容与标题严重不符的；</div>
                          </li>
                          <li>
                            <div class="rt">（2）炒作绯闻、丑闻、劣迹等的；</div>
                          </li>
                          <li>
                            <div class="rt">（3）不当评述自然灾害、重大事故等灾难的；</div>
                          </li>
                          <li>
                            <div class="rt">（4）有性暗示、性挑逗等易使人产生性联想的；</div>
                          </li>
                          <li>
                            <div class="rt">（5）展现血腥、惊悚、残忍等致人身心不适的；</div>
                          </li>
                          <li>
                            <div class="rt">（6）煽动人群歧视、地域歧视等的；</div>
                          </li>
                          <li>
                            <div class="rt">（7）宣扬低俗、庸俗、媚俗内容的；</div>
                          </li>
                          <li>
                            <div class="rt">（8）可能引发未成年人模仿不安全行为和违反社会公德行为、诱导未成年人不良嗜好等的；</div>
                          </li>
                          <li>
                            <div class="rt">（9）其他对网络生态造成不良影响的内容。</div>
                          </li>
                        </ul>
                      </div>
                    </li>

                    <li>
                      <div class="rt">
                        <p>
                          5.2不得利用我们的服务从事违法犯罪的活动，包括分裂国家、教唆他人犯罪、侵犯计算机安全系统、干扰或扰乱网络服务等危害国家安全、欺诈、洗钱及从事或资助其他违法犯罪活动或有损社会公共利益的行为。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>5.3遵守本协议及所有相关的协议、规定和程序，同时也必须遵循与因特网有关的程序和惯例。</p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>5.4不得利用或针对我们的服务进行任何危害计算机网络安全的行为，包括但不限于：</p>
                        <ul>
                          <li>
                            <div class="rt">（1）非法侵入他人网络、干扰他人网络正常功能、窃取网络数据等危害网络安全的活动；</div>
                          </li>
                          <li>
                            <div class="rt">（2）提供专门用于从事侵入网络、干扰网络正常功能及防护措施、窃取网络数据等危害网络安全活动的程序、工具；</div>
                          </li>
                          <li>
                            <div class="rt">（3）明知他人从事危害网络安全的活动的，为其提供技术支持、广告推广、支付结算等帮助；</div>
                          </li>
                          <li>
                            <div class="rt">（4）使用未经许可的数据或进入未经许可的服务器/账号；</div>
                          </li>
                          <li>
                            <div class="rt">（5）未经允许进入公众计算机网络或者他人计算机系统并删除、修改、增加存储信息；</div>
                          </li>
                          <li>
                            <div class="rt">（6）未经许可，企图探查、扫描、测试本服务系统或网络的弱点或其它实施破坏网络安全的行为；</div>
                          </li>
                          <li>
                            <div class="rt">（7）企图干涉、破坏本服务系统或平台的正常运行，故意传播恶意程序或病毒以及其他破坏干扰正常网络信息服务的行为；</div>
                          </li>
                          <li>
                            <div class="rt">（8）伪造TCP/IP数据包名称或部分名称。</div>
                          </li>
                        </ul>
                      </div>
                    </li>

                    <li>
                      <div class="rt">
                        <p>5.5不得对本平台进行反向工程、反向汇编、编译或者以其他方式尝试发现本平台的源代码。</p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          5.6不得提交、发布虚假信息；不得欺诈、强制、诱导其他用户关注、点击链接页面或分享信息；不得使用机器人或自动化程序，以虚假或欺诈的方式创建账号或购买潮玩藏品；不得冒充他人，使用他人的电子邮件地址创建账号或购买潮玩藏品。
                        </p>
                      </div>
                    </li>

                    <li>
                      <div class="rt">
                        <p>5.7不得使用未经我们授权或许可的任何插件、外挂、系统或第三方工具对本服务的正常运行进行干扰、破坏、修改或施加其他影响。</p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>5.8您应当使用自有合法资金购买潮玩藏品。</p>
                      </div>
                    </li>

                    <li>
                      <div class="rt">
                        <p>
                          5.9不得通过非法方式购买潮玩藏品，例如：盗刷信用卡或者使用其他您无权使用的支付方式或机制；不得通过非法方式获得实物收藏品的证书，例如：盗窃他人所有或占有的实物收藏品，并基于该实物收藏品获得证书。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          5.10您的购买行为应当基于真实的消费、收藏需求，而非基于投资或投机目的，不得存在对潮玩藏品实施恶意购买、价格操纵或利用潮玩藏品进行洗钱等扰乱正常平台秩序的行为。基于维护平台秩序及平台安全的需要，我们发现上述情形时可主动执行关闭相关订单等操作。
                        </p>
                      </div>
                    </li>

                    <li>
                      <div class="rt">
                        <p>5.11不得将本平台的潮玩藏品作为购买其他资产的一般等价物或凭证。</p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>5.12不得在本平台之外购买任何本平台的其它用户账号或本平台出售的潮玩藏品。如果您以其他方式购买本平台出售的潮玩藏品，产生的法律后果由您自行承担。</p>
                      </div>
                    </li>

                    <li>
                      <div class="rt">
                        <p>
                          5.13不得在本平台以外将潮玩藏品拆分成份额进行交易，不得采取集中竞价、集合竞价、连续竞价、电子撮合、做市交易等方式交易潮玩藏品。不得在本平台以外将实物收藏品的数字证书进行交易、炒作，不得采取集中竞价、集合竞价、连续竞价、电子撮合、做市交易等方式交易实物收藏品的数字证书。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          5.14请您保证对通过本平台制作、复制、上传、发布、传播、评论的任何内容（包括但不限于头像、名称、账号介绍，或文字、图片、音频、视频、链接等，以及其他使用本平台服务所产生的其他内容）享有合法权益，不得侵犯我们及我们关联公司、或其他任何第三方的专利权、著作权、商标权等知识产权、名誉权、隐私权或其他任何合法权益，或从事损害我们利益或对我们造成不利影响的行为。 <span
                            class="bold">若您账号中的内容发生权利纠纷或侵犯了任何第三方的合法权益，您需承担全部法律责任。</span></p>
                      </div>
                    </li>

                    <li>
                      <div class="rt">
                        <p>5.15除非已遵守了本协议的其它规定或已取得了我们事先许可，您不得为任何目的从事或帮助他人从事以下行为：</p>
                        <ul>
                          <li>
                            <div class="rt">（1）下载、复制、读取、采用、展示、分享、转发、传播、上载、出版、发行我们的服务内容；</div>
                          </li>
                          <li>
                            <div class="rt">（2）修改、编辑、整理、编排或以其他方式演绎我们的服务内容；</div>
                          </li>
                          <li>
                            <div class="rt">（3）转让、转售、出租我们的服务内容；</div>
                          </li>
                          <li>
                            <div class="rt">（4）采用包括但不限于特殊标识、特殊代码等任何形式的识别方法，自行或协助第三人对我们服务的信息内容产生流量、阅读量引导、转移、劫持等不利影响。
                            </div>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>5.16经我们书面事先许可后，您对我们相关服务的信息内容的分享、转发等行为，还应符合以下规范：</p>
                        <ul>
                          <li>
                            <div class="rt">
                              （1）对抓取、统计、获得的相关搜索热词、命中率、分类、搜索量、点击率、阅读量等相关数据，未经我们事先书面同意，不得将上述数据以任何方式公示、提供、泄露给任何第三人；</div>
                          </li>
                          <li>
                            <div class="rt">
                              （2）不得对本平台的源网页进行任何形式的任何改动，包括但不限于本平台的首页链接、广告系统链接等入口，也不得对本平台的源页面的展示进行任何形式的遮挡、插入、弹窗等妨碍；</div>
                          </li>
                          <li>
                            <div class="rt">（3）应当采取安全、有效、严密的措施，防止我们的信息内容被第三方通过包括但不限于网络爬虫程序等任何形式进行非法获取；</div>
                          </li>
                          <li>
                            <div class="rt">（4）不得把相关数据内容用于我们书面许可范围之外的目的，进行任何形式的销售和商业使用，或向第三方泄露、提供或允许第三方为任何方式的使用；</div>
                          </li>
                          <li>
                            <div class="rt">（5）用户向任何第三人分享、转发我们相关服务信息内容的行为，还应遵守我们为此制定的其他规范和标准。</div>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          5.17为了保护数据安全，您不得从事包括但不限于以下行为，也不得为其提供便利：
                        </p>
                        <ul>
                          <li>
                            <div class="rt">
                              （1）未经其他用户明确同意，或在未向其他用户如实披露数据用途、使用范围等相关信息的情形下收集、复制、存储、使用或传输其他用户数据，侵害其他用户合法权益；</div>
                          </li>
                          <li>
                            <div class="rt">
                              （2）将其他用户的帐号、昵称等个人信息用于任何未经用户及我们授权的用途；</div>
                          </li>
                          <li>
                            <div class="rt">（3）企图进行反射查找、跟踪、关联、挖掘、获取用户帐号、手机号和出生日期等个人信息；</div>
                          </li>
                          <li>
                            <div class="rt">（4）通过各种程序、软件等抓取任何用户的信息或与本服务相关的任何信息、数据；</div>
                          </li>
                          <li>
                            <div class="rt">（5）未经我们授权使用任何第三方软件、插件、外挂、系统等查看、获取本服务中所包含的我们及我们合作伙伴或用户的任何相关信息、数据等内容；</div>
                          </li>
                          <li>
                            <div class="rt">
                              （6）其他危害数据安全的行为。
                            </div>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          5.18您在使用我们的服务时违反上述任何规定，我们可自行判断并处理，要求您改正或采取一切必要的措施（包括但不限于删除您上传的内容、暂停或终止您使用本平台、删除您的潮玩藏品图像和描述、没收您购买获得的全部潮玩藏品）以减轻您不当行为造成的影响，且在任何时候有权在不进行任何事先通知的情况下终止向您提供服务，并追究相关责任。
                          <span class="bold">
                            违反上述任何规定产生任何法律后果的，应以您自己的名义独立承担所有的法律责任，造成我们损失或造成我们被第三人索赔的，您应全额赔偿我们的一切损失和费用（包括但不限于各种赔偿费、诉讼代理费及为此支出的其他合理费用）
                          </span>
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          5.19若您发现本平台内用户发布的内容（包括但不限于图片、视频、文字作品等）侵犯您的在先权利，您可以通过info@mints.cn联系我们进行举报，并提供相应的证明资料，我们核实后将及时采取措施制止侵权行为。
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>

              <li>
                <div class="rt">
                  <p class="bold">六、潮玩藏品的权利及限制</p>
                  <ul>
                    <li>
                      <div class="rt">
                        <p>
                          6.1您可以通过本平台购买由各领域的顶尖创作家创作的<span
                            class="bold">潮玩藏品</span>按照本协议的约定获取、购买潮玩藏品之后，您对潮玩藏品拥有的权利将受到限制，您仅可以将该潮玩藏品列入您的收藏欣赏、浏览及向其他用户展示您的潮玩藏品。
                          <span
                            class="bold"> 潮玩藏品元数据中的创作者、创作和上链时间、购买者等信息，一经确认则不可篡改，当您购买潮玩藏品后，潮玩藏品所对应的包括购买者信息登记将计入您的账号并在我们运行和维护的【潮玩藏品权证登记链】进行登记，作为您持有该潮玩藏品的凭证，以实现您对潮玩藏品权利登记的不可篡改性和唯一性。您理解和同意，为了进行前述购买和登记，您的邮箱可能会被公开。此外，潮玩藏品登记可能有一定延迟，您无法在购买后即时查看潮玩藏品的登记。在您购买潮玩藏品并完成登记后，您可通过您的账号登录本平台查看该潮玩藏品的登记权利凭证，但您无权要求提取该登记权利凭证或将登记权利凭证转入您的其他电子钱包，亦无权要求我们将该潮玩藏品或其登记权利凭证导入至其他平台或在任何其他平台或机构对您的潮玩藏品进行登记。</span>
                        </p>
                      </div>
                    </li>

                    <li>
                      <div class="rt">
                        <p>
                          6.2对于您根据本协议、通过本平台购买的潮玩藏品，权利人将授予您一项在版权有效期内的、非独占的、非排他的、不可分许可的、仅限个人非商业目的用途的收藏、使用和展示您所购买的潮玩藏品的许可
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          6.3除本协议明确约定的内容以外，或者您另行取得著作权人及相关权利人书面授权，无论您通过本平台还是其他任何方式获得潮玩藏品，我们和著作权人及相关权利人都不会授予您对潮玩藏品的任何权利和许可（包括但不限于著作权）。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p><span
                            class="bold">6.4上文第6.2条授予的许可仅在您拥有潮玩藏品的时间范围内适用。</span>如果您注销账号或出于任何原因放弃您已购买的潮玩藏品，上文第6.2条授予的许可将立即到期，而无需另行通知。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt bold">
                        <p class="bold">6.5您不得，且不得允许任何第三方实施以下行为：</p>
                        <ul>
                          <li>
                            <div class="rt bold">（1）复制、分发、修改、改编、翻译潮玩藏品，或以其他方式开发任何衍生作品；</div>
                          </li>
                          <li>
                            <div class="rt bold">
                              （2）将潮玩藏品用于任何商业目的，包括但不限于用于电影、视频或任何其他形式的媒体、纸质或电子出版物（包括但不限于音视频出版物）的封底、封面、插画、内容、软件或移动应用、线上或线下广告、销售或促销，及其他任何形式的商业活动、广告宣传、潮玩藏品推广等；
                            </div>
                          </li>
                          <li>
                            <div class="rt bold">
                              （3）将潮玩藏品用于或关联于任何违反国家法律法规、政策、社会公序良俗、色情淫秽、暴力残忍、非法言论、不道德和/或侵犯第三人合法权利、权益的用途、场景；
                            </div>
                          </li>
                          <li>
                            <div class="rt bold">（4）将潮玩藏品（部分或全部）作为自身或其他第三方的商标、服务标记、标识、logo、原产地标识或其他商业标识；</div>
                          </li>
                          <li>
                            <div class="rt bold">（5）试图为您所购买潮玩藏品注册商标、版权或以其他方式获得额外的知识产权；</div>
                          </li>
                          <li>
                            <div class="rt bold">（6）将潮玩藏品存储在任何以共享、转让信息或内容为目的的平台、系统、互联网、共享硬盘或类似设备上，供他人免费或付费浏览、下载、调取。
                            </div>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          6.6您理解并同意，由于购买行为一经发生即会被详细地记录上，您在本平台购买潮玩藏品的行为是不可撤销的，如您因认知错误、操作失误、第三方欺诈等原因购买潮玩藏品，我们亦无法撤销或恢复，您应对您的购买行为承担全部责任。特别提醒您，本平台出售的潮玩藏品不支持七天无理由退换。一旦您购买潮玩藏品，您无权反悔要求退回、更换该潮玩藏品或退款。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          6.7您理解并同意，您在本平台上购买潮玩藏品的行为可能根据适用的法律法规产生一定的税费，您应当负责按时支付全部税费并承担未履行相关义务时可能产生的全部法律责任。您无权从您应向我们或者其他用户支付的款项中扣除税费等其他额外产生的费用。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          6.8如果您购买的潮玩藏品包含第三方知识产权，您理解并同意，您无权在潮玩藏品之外使用第三方知识产权，例如：销售、分销包含第三方知识产权的商品。您使用潮玩藏品的权利可能受到第三方知识产权权利人的限制，您应当在我们向您书面通知此类限制时遵守的限制，否则，您应当承担全部可能产生的法律后果和责任。
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>

              <li>
                <div class="rt bold">
                  <p>七、实物收藏品的数字证书之权利与限制</p>

                  <ul>
                    <li>
                      <div class="rt">
                        <p>
                          7.1您理解并同意，您通过本平台获得的实物收藏品的数字证书是实物收藏品的凭证。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          7.2实物收藏品的数字证书本身不具有交换价值，仅为确权工具，不得用于炒作、场外交易和任何商业用途。如发现您的账号存在炒作实物收藏品的数字证书等异常行为、涉嫌违法违规或本协议禁止的行为，我们有权采取必要的限制措施，包含但不限于冻结您的账号等。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          7.3当实物收藏品的所有权发生转移时，实物收藏品的所有者可以在本平台申请该实物收藏品的数字证书的赠送，本平台在审核通过后将在合理时间内协助实物收藏品的持有者完成数字证书的转移。为防止炒作，您理解并同意，您在获得实物收藏品的数字证书需持有【180
                          】日方可赠送。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          7.4您理解并同意，本平台有权随时关闭实物收藏品的数字证书的赠送功能。
                        </p>
                      </div>
                    </li>

                  </ul>
                </div>
              </li>

              <li>
                <div class="rt">
                  <p>八、知识产权保护</p>
                  <ul>
                    <li>
                      <div class="rt">
                        <p>
                          对于本平台的相关内容，我们将根据以下规则保护我们和您的知识产权：</br>
                          8.1除另有约定外，本平台的内容、代码、数据等所有元素的所有权和所有法律权利、以及其中所有知识产品（包括但不限于潮玩藏品、系统、方法、信息、代码、软件、服务、组织、内容、数据、技术、程序、网页、文字、图片、图表、外观、外观设计、简报、应用程序，和所有其他元素的汇编）的知识产权及本平台上相关数据的权利均属于我们所有。未经我们事先书面许可，您不能进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现我们的源代码，不能出租、出借、修改、链接、汇编、发表、出版、转载、复制、拷贝、出售、转售、访问、爬取、建立镜像站点或者使用任何部分的内容、数据、代码和外观设计。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          8.2我们尊重您的知识产权。为了向您提供我们的服务（例如：展示您上传的文字、语音、图片、视频、图文等），您同意授予我们一项全球的、免费的、可转让、非独占和不可撤销的权利，在不侵犯您商业秘密和个人信息的前提下，使用您在使用我们的服务中向我们提供或生成的所有信息和数据。除此之外，除非获得了您的同意，我们不会擅自使用、修改、复制、公开传播、改变、散布、发行或公开发表您拥有知识产权的成果。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          8.3所有与本平台以及本平台内容相关的商标、服务标志、编号均为我们或我们许可方的专有财产。未经我们事先书面授权同意，您不得在世界任何国家和地区将本平台Logo等文字、图形及其组合，以及本平台的其他标识、商号、徽记、APP名称、网站名称、服务名称、服务标记以任何方式展示、使用或申请注册商标、进行域名注册等，也不得实施向他人明示或暗示有权展示、使用、或其他有权处理上述标识的行为。如因您非法使用上述标识等给我们或他人造成损失的，由您承担全部法律责任。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          <span class="bold">
                            8.4您应尊重我们和第三方的知识产权和其他合法权利/权益，保证在使用本平台服务时上传的文字、图片、视频、软件以及表演等信息不侵犯任何第三方的知识产权、名誉权、姓名权、隐私权等合法权益，并保证在发生侵犯前述权益的违法事件时，保护我们及我们的雇员、股东、合作伙伴等免于因该等事件受到影响或损失。我们保留在您侵犯我们及/或其他第三方的合法权利/权益时终止向您提供服务并不退还任何款项的权利，您应自行承担全部赔偿责任，并且赔偿我们因此遭受的包括但不限于经济、企业商誉等损失。
                          </span>
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>8.5任何组织或个人认为本平台的内容侵犯其知识产权的，可通过info@mints.cn向我们提出书面权利通知和侵权的初步证据，我们将在收到知识产权权利人合格通知后依法尽快处理。
                        </p>
                      </div>
                    </li>

                  </ul>
                </div>
              </li>

              <li>
                <div class="rt">
                  <p>九、关于本软件</p>
                  <p class="desc">
                    9.1我们开发并按照本协议之约定授权您下载、安装、登录、使用薄盒软件（<span class="bold">“本软件”</span>）。
                    <br>您可以通过手机终端以APP的形式使用本软件，同时，我们会不断丰富您使用本软件的终端、形式等。当您使用本软件时，您应选择与您的终端、系统等相匹配的软件版本，否则，您可能无法正常使用本软件。
                  </p>
                  <p class="desc">
                    9.2我们授予您一项个人的、不可转让及非排他性的许可，以按照本协议及其他单项产品协议限定的范围和方式使用本软件。您且仅限于您个人，可为非商业目的在单一台终端设备上下载、安装、使用、登录本软件。</p>
                  <p class="desc">9.3您可以直接从我们的官方网站，以及授权的第三方网站和应用分发平台获取本软件。</p>
                  <p class="desc bold">9.4如果您从未经我们授权的第三方获取本软件或与本软件名称相同的安装程序，我们无法保证该软件能够正常使用，并对因此给您造成的损失不负任何责任。</p>
                  <p class="desc">9.5我们可能为不同的终端、系统等开发不同的软件版本，您应当根据实际情况选择下载合适的版本进行安装。下载安装程序后，您需要按照该程序提示的步骤正确安装。</p>
                  <p class="desc">9.6如果您不再需要使用本软件或者需要安装新版软件，可以自行卸载。如果您愿意帮助我们改进产品服务，请告知我们卸载的原因。</p>
                  <p class="desc">9.7为了增进用户体验、完善服务内容，我们可能不断努力开发新的服务，并为您不时提供软件更新。</p>
                  <p class="desc bold">9.8为了改善用户体验或提高服务安全性、保证功能的一致性等目的，我们有权对本软件进行更新，或者对本软件的部分功能效果、服务内容进行改变。</p>
                  <p class="desc">9.9本软件新版本发布后，旧版本的软件可能无法使用。我们不保证旧版本软件继续可用，也不保证继续对旧版本软件提供相应的客服和维护服务，请您随时核对并下载最新版本。</p>
                  <p class="desc">9.10本软件可能会使用第三方软件或技术（包括本软件可能使用的开源代码和公共领域代码等，下同），这种使用已经获得合法授权。</p>
                  <p class="desc">
                    9.11本软件如果使用了第三方的软件或技术，我们将按照相关法规或约定，对相关的协议或其他文件，可能通过在本软件安装包特定文件夹中打包等形式进行展示，它们可能会以“软件使用许可协议”“授权协议”“开源代码许可证”或其他形式来表达。
                  </p>
                  <p class="desc">9.12前述相关协议或其他文件均是本协议不可分割的组成部分，与本协议具有同等的法律效力，您应当遵守这些要求。<span
                      class="bold">如果您没有遵守这些要求，该第三方或者国家机关可能会对您提起诉讼、进行罚款或采取其他制裁措施，并要求我们给予协助，您应当自行承担法律责任。</span></p>

                </div>
              </li>
              <li>
                <div class="rt">
                  <p>十、个人信息保护政策</p>
                  <p class="desc">
                    我们非常重视和保护您的个人信息，制定了专门的<span class="bold"><a href="/publicAgreement?agreementCode=H5YSZC"
                        style="color:#83878B;font-weight:bold">《薄盒隐私政策》</a></span>。在您使用我们提供的服务前，请您务必进行阅读。
                  </p>
                </div>
              </li>
              <li>
                <div class="rt">
                  <p>十一、赔偿</p>
                  <p class="desc">
                    因您违反本协议而导致的任何第三方向我们或我们的关联方提出的索赔或请求，您应当承担赔偿责任，包括但不限于诉讼费用、律师费用、差旅费用、和解金额、罚款或生效法律文书中规定的损害赔偿金额、软件使用费等，且您应为我们抗辩或消除影响，保护我们不受损害。
                  </p>
                </div>
              </li>
              <li>
                <div class="rt bold">
                  <p>十二、责任限制</p>
                  <p class="desc bold">请您知晓并理解，在以下情形中，我们不对由此给您造成的任何损失或损害承担任何责任：</p>
                  <ul>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          12.1我们将尽力为您提供畅通无阻、连贯安全的网络服务，但网络服务可能受多种因素的影响，我们不能保证向您提供的服务是连续的、即时的、准确的，也不能随时预见和防范法律、技术以及其他风险，包括但不限于不可抗力、病毒、木马、黑客攻击、系统不稳定、第三方服务瑕疵、政府行为等原因可能导致的服务中断、数据丢失、钱包文件损坏以及其他的损失和风险。我们的服务内容将依现状提供，我们不作任何形式的有关服务内容的准确性、完整性、令人满意的品质、不侵权或适合某一特殊目的的保证。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          12.2潮玩藏品购买的确认需要一定时间，且在某些情况下可能无法完成，例如硬件、软件或网络连接故障、恶意代码或计算机病毒、支付系统、权证登记系统故障导致购买无法完成。在任何情况下我们无需对上述事项向您或任何第三方承担责任。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          12.3我们保留随时修改、增减、取消、暂停、中断或终止提供本平台全部或部分服务而无需事先告知您的权利，亦无需对您和第三方承担任何责任。服务器如因系统维护或升级而需暂停服务时，我们将尽量事先公告。如因系统维护、升级而需暂停服务或因服务器故障、硬件故障、其他不可抗力因素而导致停止服务，于暂停服务期间造成的一切不便和资料、数据等遗失，我们将尽力挽救恢复；如确实无法恢复，我们不承担任何责任。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          12.4我们将尽可能地在服务中提供准确的信息。服务所涉及的潮玩藏品图片、演示图和示意图仅供参考（图片为合成图、模拟演示图）。限于篇幅，本协议中所包含的信息（包括但不限于潮玩藏品功能说明等）可能不完整，请以有关潮玩藏品使用说明书的具体信息为准。我们不保证提供的服务和潮玩藏品完全符合您的使用要求，或完全符合您的期望。我们保留随时更改潮玩藏品的设计、规格的权利，而无需事先通知您。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          12.5对于您自本平台获得的他人的信息、内容、声明或者广告宣传等任何资讯，我们不负保证真实性、准确性、完整性以及合法性的责任。如果任何单位或者个人通过上述“信息”而进行任何行为，须自行甄别真伪和谨慎预防风险，否则，无论何种原因，我们不对任何非于本平台直接发生的交易和(或)行为承担任何直接、间接、附带或衍生的损失和责任。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          12.6我们不承担由于您提供信息而可能产生的任何责任，包括但不限于因您在没有获得授权的情形下使用信息，或因您提供信息包含错误、不准确、病毒、诽谤、中伤、侵权等著作权法、隐私和个人信息保护相关法律或其他任何法律所禁止的内容或其他内容而产生的任何责任。我们亦不对您提供的信息在任何情形下的丢失、删除、移除或传输失败承担任何责任，您应对其提供信息自行保留备份。我们保留随时删除或移除任何您提供信息的权利，而无需通知您，且不需承担任何责任。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          12.7您知悉并同意，潮玩藏品的价值具有较大主观性，我们或任何第三方对潮玩藏品目前及未来的价值均不作出任何承诺。您同意您将在不依赖我们服务的情况下独立评估潮玩藏品的价格。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          12.8我们的服务内容可能含有与第三方服务的链接或接入第三方提供的服务，这些第三方仅为您提供便利，不代表我们经营或参与经营这些服务，亦不代表您被授予访问或使用这些服务的许可，您应自担责任（包括但不限于遵守该第三方的使用条款）并自付费用访问这些服务，我们不对这些服务的内容和行为负责。对于您在本平台之外，与第三方发生的任何法律行为，包括但不限于与第三方的交易，由您与该第三方自行承担全部的责任，我们并不控制或支持此类交易，因此我们不承担任何责任。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          12.9由于我们提供的产品和服务具有一定的创新性，当前的法律、法规、部门规章等规范性行文件、监管政策可能随时发生变化并对我们提供的产品和服务产生重大影响。您知悉并同意，我们无法保证向您连续提供相关服务并维持您的潮玩藏品的初始价格，我们可能会根据需要更新或调整我们的服务内容，甚至中止、终止向您提供全部或部分服务。您认可并同意，为了保障交易安全、合法、有序以及履行我们反洗钱的义务，我们有权对您的账户进行安全查询。如发现存在欺诈等异常情形，或您存在违反法律法规或本协议约定等情形，我们有权对您采取屏蔽或者限制使用等必要措施。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          12.10由于我们提供的潮玩藏品可能包含某些电视剧、电影、音乐、图片、视听作品等领域的片段，如果因为突发政策性要求导致全网范围内下架某部作品或某人的作品，本平台将按照政策要求下架与其相关的潮玩藏品，您同意我们将不承担相关责任。下架后，您可能无法购买以及公开展示该等潮玩藏品，但您已经购买的潮玩藏品仍可以在您的个人中心查看。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          12.11我们提供的产品和服务依赖于我们运行和维护的【潮玩藏品权证登记链】，所有智能合约在分散的账本上执行和发生，我们对智能合约没有控制权，也无法作出任何保证和承诺，您知悉并同意，我们不会对由此产生的任何后果和责任向您承担法律责任。同时，我们对由于流量网络的任何其他功能或任何电子钱包造成的损失不承担任何责任，包括但不限于开发者或代表最新报告的（或完全不报告）的任何网络问题，包括技术性节点问题或其他任何导致资金损失的问题。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          12.12您特此承认并接受：对于您因使用本服务而遭受的任何直接或间接的损失，包括但不限于由于服务内容或服务的延误、不准确、错误和遗漏而产生的任何损害、责任、请求、损失或费用，我们及我们的关联方不承担任何责任。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          12.13出于某些原因如公司经营策略调整等，我们可能会关闭本平台及所属服务器，该行为将会导致您不能继续通过本平台享受由我们向您提供的有关服务，如对潮玩藏品独特的展示方式或针对潮玩藏品的有关服务等，您理解并同意，我们不会对由此产生的任何后果和责任向您承担法律责任。但该行为不会导致您丧失已享有的潮玩藏品的有关权利，您持有潮玩藏品的相关信息仍然被记录在相关账户上，您仍可以通过有关渠道查看您所持有的潮玩藏品，届时我们会将有关渠道提供给您。
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>

              <li>
                <div class="rt">
                  <p>十三、法律适用与争议解决</p>
                  <p class="desc">
                    本协议的解释和执行均适用中华人民共和国法律。倘本协议之任何规定因与中华人民共和国法律抵触而无效，则这些条款将尽可能接近本协议原条文意旨重新解析，且本协议其它规定仍应具有完整的效力及效果。如果本协议的内容与适用的强制性法律规定不一致，则以该强制性法律规定为准。
                    <span class="bold">因该协议的履行产生的任何纠纷，首先由双方协商解决；协商不成的，任何一方均可向北京擘盒科技有限公司所在地有管辖权的人民法院提起诉讼。</span>
                  </p>
                </div>
              </li>

              <li>
                <div class="rt">
                  <p>十四、其他条款</p>
                  <ul>
                    <li>
                      <div class="rt">
                        <p>
                          14.1您在使用我们的服务时，根据所涉及的服务内容，可能需要同时遵守其他协议或条款。本协议及其他协议或条款，共同构成我们与您之间关于使用我们的服务的完整协议。您仅在完全同意该完整协议的前提下，方可使用该有关的服务。

                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>14.2您和我们，即北京擘盒科技有限公司，双方均是独立的主体，在任何情况下本协议不构成双方之间的代理、合伙、合营或雇佣关系。</p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>14.3本协议的解释权及相关服务的解释权归北京擘盒科技有限公司所有。</p>
                      </div>
                    </li>
                    <li>

                      <div class="rt">
                        <p>14.4本协议各标题仅供参考，不作为解释条款内容的依据。</p>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>

            </ul>
          </section>
        </article>

      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "about",
    mounted() {
      window.scrollTo(0, 0);
    }
  }

</script>

<style scoped="scoped">
  .contentTerms {
    background: #0C0C0C;
  }

  * {
    margin: 0;
    padding: 0;
  }

  a {
    word-break: break-all;
  }

  a:link {
    color: #5bb6fa;
  }

  /* 未被访问的链接 */
  a:visited {
    color: #935171;
  }

  /* 已被访问的链接 */
  a:hover {
    text-transform: uppercase;
  }

  /* 鼠标指针移动到链接上 */
  /* a:active {background:#FF704D;}  正在被点击的链接 */

  li {
    list-style: none;
  }

  .content {
    /* padding-top: 56px; */
  }

  .intro {
    color: #BDBDBD;
    font-size: 12px;
  }

  .topTitle {
    color: #f5f4f9;
    font-size: 17px;
    font-weight: bold;
    text-align: center;
    display: inline-block;
    margin-bottom: 17px;
  }

  .topTitle img {
    width: 47px;
    height: 47px;
    object-fit: cover;
    display: inline-block;
    vertical-align: middle;
  }

  .content {
    /* position: absolute;
    top: 15px;
    right: 16px;
    left: 16px;
    bottom: 0;
    background-color: #0C0C0C;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.5);
    border-radius: 4px; */
  }

  .mainDiv {
    /* position: absolute;
    top: 15px;
    right: 0;
    left: 0;
    bottom: 15px;
    overflow-y: scroll;
    padding: 15px 15px 0 15px;
    box-sizing: border-box;
    text-align: left; */

    padding: 10px;
    font-size: 14px;
    color: #8d8f9f;
    line-height: 1.75;
  }

  .main {}

  .privacy-content {
    color: #83878B;
    font-size: 12px;
  }

  .privacy-content ul li {
    /* display: flex;
    align-items: flex-start; */
  }

  .privacy-content>ul>li {}

  .privacy-content ul li .lf {
    text-align: right;
  }

  .privacy-content ul li .rt {
    text-align: left;
  }

  .privacy-content ul li p {}

  .privacy-content .desc {}

  .privacy-content .desc a {
    color: #83878b;
  }

  .bold {
    font-weight: bolder;
  }

</style>



// WEBPACK FOOTER //
// src/views/userAgreementAndroid.vue